import React from "react";
import wizardStyle from "../wizardStyle";
import Paper from "@mui/material/Paper";
import FormFader from "../Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import { Box } from "@mui/material";
import { translate } from "../../../services/translations/translations";

export default function ContractDescription({ submitProps, alternateDescription }: any) {
  const { handleSubmit, values } = useForm();

  const opposingPartyLabel =
    values.contractPartyType === "tenant"
      ? translate("rentalContract.contractPartyType.options.landlord.label", values)
      : translate("rentalContract.contractPartyType.options.tenant.label", values);

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Ihr Vertrag
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>Beschreibung der Situation</strong>
              </FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>
                {alternateDescription ||
                  `Bitte schildern Sie uns hier Ihre Situation und Fragen. Jede Information hilft uns dabei, Ihren Fall besser einschätzen zu können. Im Anschluss können Sie ergänzend noch Vertrags-Dokumente oder Schriftverkehr mit dem ${opposingPartyLabel} hochladen, um Ihre Schilderungen zu ergänzen.`}
              </FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="personalTextMessage"
                label="Ihre Situation und Fragen"
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                rows={10}
                validators={[requiredValidator("Bitte schildern Sie uns hier kurz Ihre Situation und Ihre Fragen.")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
